<template>
	<div id="login">
		<div class="header"  @click="goIndex">
			<img src="../images/headerLogo.png" alt="" class="headerLogoImg" />
		</div>

		<div class="mainContent">
            <div class="bigTitle">手机快捷登录/注册</div>
			<div class="formBox">
				<div class="inputLine phoneLine">
					<input type="text" placeholder="请输入手机号" class="phoneInput" v-model="phone" @input="inputPhone" />
                    <button id="codeBtn" @click="sendCode" :disabled="isDisabled">{{msg}}</button>
				</div>
				<div class="inputLine codeLine">
					<input type="number" placeholder="请输入6位验证码" class="codeInput" v-model="code" @input="inputCode"  />
					
				</div>
				<div class="errorMsg">{{errormsg}}</div>
			</div>
            <div class="btnBox">
                <button id="submitBtn" class="btn-long btn-red" @click="submitClick">登录 / 注册</button>
                <a href="tel:0571-86221010" >
                    <button  class="btn-long btn-red reverse">
                        <img src="../images/newImages/but_ic_phone.png" alt="" class="btnIcon"> 0571-86221010
                    </button>
                </a>

            </div>

			<div class="bottomImgBox">
                © 2017-2019 杭州亿尚智能科技有限公司 版权所有
			</div>

		</div>

	</div>
</template>

<script>
	import { ajaxCode, ajaxLogin } from '@/assets/request.js'
	import { setCookie,phoneReg,codeReg,filterPhoneNum } from '@/assets/common.js'
	export default {
		data() {
			return {
				isDisabled: false,
				msg: "获取验证码",
				phone: "",
				code: "",
				regExp: phoneReg,
				codeReg:codeReg,
				errormsg: ""
			}
		},
		methods: {
			goIndex(){
				this.$router.push("/")
			},
			inputPhone() {
				this.phone=filterPhoneNum(this.phone)
				if(this.regExp.test(this.phone)) {
					this.errormsg = ""
				} else {
					this.errormsg = "请输入正确的手机号"
				} 
			},
			inputCode() {
				if(this.codeReg.test(this.code)) {
					this.errormsg = ""
				} else {
					this.errormsg = "验证码为6位数字"
				}
			},
			sendCode() {
				let _this = this
				if(!this.regExp.test(this.phone)) {
					this.errormsg = "请输入正确的手机号"
					return false
				} else {
					this.isDisabled = true
					let num = 60
					_this.msg = num + "s"
					let timer = setInterval(function() {
						if(num <= 1) {
							clearInterval(timer)
							_this.isDisabled = false
							_this.msg = "获取验证码"
						} else {
							num--
							_this.msg = num + "s"
						}
					}, 1000)
					ajaxCode(_this.phone).then(res => {
						this.$message.success({
							message:"发送成功",
							duration: 1000,
						});
					}, (res) => {
						this.$message.error({
							message:res.erroyMsg,
							duration: 1000,
						});
					})
				}
			},
			submitClick() {
				let _this = this
				if(!this.regExp.test(this.phone)) {
					this.errormsg = "请输入正确的手机号"
				} else if(!this.codeReg.test(this.code)) {
					this.errormsg = "请输入正确的验证码"
				} else {
					ajaxLogin(_this.phone, _this.code).then(res => {

						this.$message.success({
							message: "登录成功",
							duration: 1000,
							onClose: () => {
								let token=JSON.parse(res.data).token
								let userId=JSON.parse(res.data).userId
								console.log(token,userId)
								sessionStorage.setItem("isLogined","1")
								sessionStorage.setItem("token",token)
								sessionStorage.setItem("userId",userId)
								setCookie("global_token",token,10)
								_this.$router.back()
							}
						});

					}, (res) => {
						this.$message.error({
							message:res.erroyMsg,
							duration: 1000,
						});
					})
				}
			}
		},
		mounted() {}
	}
</script>

<style lang="less" scoped="scoped">
    #login{
        // *{outline: 1px solid blue;}
        input{font-size: 0.36rem;}
        .header {
        	position: fixed;
        	top: 0;
        	left: 0;
        	right: 0;
            padding:0.6rem 0 0.2rem;
            border-bottom: 1px solid #f5f5f5;
        	background: #fff;
        	font-size: 0.32rem;
        	img {
        		height: 0.44rem;
        	}
            text-align: center;
            .headerLogoImg{}
        }
        .mainContent{
            margin-top:1.28rem; padding:0 0.32rem; background: #fff;
        }
        .bigTitle{
            color:#333;font-size: 0.48rem;font-weight: bold; padding-top:1.13rem;padding-bottom:0.54rem;
        }
        .inputLine{
            border-bottom:1px solid #eee;;
            input{border:none;height: 0.48rem; line-height: 0.48rem; padding:0.28rem 0;} 
        }
        #codeBtn{border:none;background: none;float:right;font-size:0.28rem; height: 0.88rem;color:#333;}
        .errorMsg{height: 0.8rem;margin-top:0.16rem; text-align: center; font-size: 0.24rem; color:red;}
        #submitBtn{margin-bottom:0.4rem; }
        .bottomImgBox{color:#ccc;font-size: 0.24rem; text-align: center; margin-top: 3.49rem;}
        .btnBox{
            button.btn-long{font-size: 0.36rem ;}
            .btnIcon{
                width: 0.48rem;height: 0.48rem; vertical-align: bottom;
            }
        }

    }
    
   
	
</style>


// WEBPACK FOOTER //
// src/page/login.vue